import { useNavigate } from '@tanstack/react-router';
import { Button } from './ui/button';
import { useTranslation } from 'react-i18next';

const ChooseDifferentOptionBtn = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onClick = () =>
    navigate({
      to: '/payments/payment-methods',
      search: (prev) => ({ ...prev, paymentType: undefined, step: 1 }),
    });

  return (
    <Button type='button' variant='outline' onClick={onClick}>
      {t('Choose a Different Option')}
    </Button>
  );
};

export default ChooseDifferentOptionBtn;
